/** @param {string} hex */
export function hexToRgb(hex) {
  if (!hex || typeof hex !== 'string') return null;
  let h = hex.replace('#', '').trim();
  if (h.length === 3) {
    h = h
      .split('')
      .map((c) => c + c)
      .join('');
  }
  if (h.length !== 6 || Number.isNaN(parseInt(h, 16))) return null;
  const n = parseInt(h, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

/** @param {string} hex @param {number} [alpha] */
export function rgbaFromHex(hex, alpha = 1) {
  const rgb = hexToRgb(hex);
  if (!rgb) return `rgba(99, 102, 241, ${alpha})`;
  return `rgba(${rgb.r},${rgb.g},${rgb.b},${alpha})`;
}

/** @param {string} hex @param {number} [amount] */
export function mixWithWhite(hex, amount = 0.35) {
  const rgb = hexToRgb(hex);
  if (!rgb) return hex || '#6366f1';
  const r = Math.round(rgb.r + (255 - rgb.r) * amount);
  const g = Math.round(rgb.g + (255 - rgb.g) * amount);
  const b = Math.round(rgb.b + (255 - rgb.b) * amount);
  return `rgb(${r},${g},${b})`;
}

/**
 * CSS variables for micro-learning panel (theme from Redux `getThemeColor`).
 * @param {string} [themeColor]
 */
export function getMicroLearningThemeVars(themeColor) {
  const primary =
    themeColor && typeof themeColor === 'string' && themeColor.trim() !== ''
      ? themeColor.trim()
      : '#6366f1';
  return {
    '--ml-primary': primary,
    '--ml-gradient-mid': mixWithWhite(primary, 0.38),
    '--ml-gradient-accent': mixWithWhite(primary, 0.12),
    '--ml-badge-end': mixWithWhite(primary, 0.22),
    '--ml-icon-glow': rgbaFromHex(primary, 0.22),
    '--ml-glow-a': rgbaFromHex(primary, 0.12),
    '--ml-glow-b': rgbaFromHex(primary, 0.06),
    '--ml-glow-c': rgbaFromHex(primary, 0.14),
  };
}
